import { TYPES as CASH_COUNT_TYPES } from 'src/models/cash/CashCount'
import CashSession from 'src/models/cash/CashSession'
import Model, { encoders, ID, IsoDateTime } from 'src/models/Model'
import RegisterStation from 'src/models/register/RegisterStation'
import User from 'src/models/user/User'

export default class CashAdjustment extends Model {
  static name = 'CashAdjustment'

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.PointOfSale, Model.permissionCategories.HardwareAndRegisterStation]

  static define () {
    this.fields = {
      id: {
        type: ID
      },

      adjustedAt: {
        type: IsoDateTime,
        default: null
      },

      registerStation: {
        type: RegisterStation,
        reference: true
      },
      user: {
        type: User,
        reference: true,
        encode: encoders.hasOne,
        default: null
      },

      amount: {
        type: Number,
        encode: encoders.cents,
        default: 0
      },
      description: {
        type: String
      },

      cashSession: {
        type: CashSession,
        reference: true,
        encode: encoders.hasOne,
        output: true
      },

      createdAt: {
        type: IsoDateTime,
        output: true
      }
    }

    this.computed = {
      isUserRestricted () {
        // If cash session is restricted to a user
        if (this.registerStation.registerType.cashCountType === CASH_COUNT_TYPES.CASH_TRAY && this.registerStation.registerType.enableRestrictedUserCashSessions) {
          // Only the owning user or an admin can open the cash session
          if (this.user?.id !== this.context.currentUser?.id && !this.context.currentUser?.admin) return true
        }

        return false
      }
    }
  }

  encode () {
    if (!this.user) this.user = this.context.currentUser

    if (!this.registerStationId) this.registerStationId = this.context.currentRegisterClient?.registerStation?.id

    if (!this.adjustedAt) this.adjustedAt = new IsoDateTime()

    return this.data
  }
}
